import { resolveFeatureFlag } from '../types/index.js';
export class Tenant {
    props;
    constructor(props) {
        this.props = props;
    }
    static create(params) {
        if (!params.name.trim())
            throw new Error('Tenant name cannot be empty');
        if (!/^[a-z0-9-]+$/.test(params.slug)) {
            throw new Error('Tenant slug must be lowercase alphanumeric with hyphens');
        }
        const now = new Date();
        return new Tenant({
            id: params.id,
            name: params.name.trim(),
            slug: params.slug,
            status: 'active',
            config: {
                timezone: 'America/Santiago',
                locale: 'es-CL',
                enabledFeatures: {},
                ...params.config,
            },
            createdAt: now,
            updatedAt: now,
        });
    }
    static reconstitute(props) {
        return new Tenant(props);
    }
    get id() {
        return this.props.id;
    }
    get name() {
        return this.props.name;
    }
    get slug() {
        return this.props.slug;
    }
    get status() {
        return this.props.status;
    }
    get config() {
        return this.props.config;
    }
    /** Explicit switch, else the flag's registered default (`FEATURE_FLAGS`). */
    isFeatureEnabled(flag) {
        return resolveFeatureFlag(this.props.config.enabledFeatures, flag);
    }
    suspend() {
        return new Tenant({ ...this.props, status: 'suspended', updatedAt: new Date() });
    }
    updateConfig(config) {
        return new Tenant({
            ...this.props,
            config: { ...this.props.config, ...config },
            updatedAt: new Date(),
        });
    }
    toSnapshot() {
        return { ...this.props };
    }
}
export class Membership {
    props;
    constructor(props) {
        this.props = props;
    }
    static create(params) {
        if (params.roles.length === 0) {
            throw new Error('A membership must have at least one role');
        }
        return new Membership({
            ...params,
            status: 'active',
            joinedAt: new Date(),
        });
    }
    static reconstitute(props) {
        return new Membership(props);
    }
    get uid() {
        return this.props.uid;
    }
    get tenantId() {
        return this.props.tenantId;
    }
    get roles() {
        return [...this.props.roles];
    }
    get personId() {
        return this.props.personId;
    }
    get email() {
        return this.props.email;
    }
    get displayName() {
        return this.props.displayName;
    }
    get status() {
        return this.props.status;
    }
    hasRole(role) {
        return this.props.roles.includes(role) || this.props.roles.includes('tenantAdmin');
    }
    isActive() {
        return this.props.status === 'active';
    }
    suspend() {
        return new Membership({ ...this.props, status: 'suspended' });
    }
    /** Quita UN cargo (p. ej. «student» al retirarse) sin tocar los demás. Si era
     *  el único, la membresía queda suspendida con sus cargos intactos: así se
     *  puede revertir y nunca queda una membresía sin cargos. */
    withoutRole(role) {
        if (!this.props.roles.includes(role))
            return this;
        const rest = this.props.roles.filter((r) => r !== role);
        return rest.length === 0 ? this.suspend() : new Membership({ ...this.props, roles: rest });
    }
    addRole(role) {
        if (this.props.roles.includes(role))
            return this;
        return new Membership({ ...this.props, roles: [...this.props.roles, role] });
    }
    removeRole(role) {
        const roles = this.props.roles.filter((r) => r !== role);
        if (roles.length === 0)
            throw new Error('Cannot remove last role from membership');
        return new Membership({ ...this.props, roles });
    }
    toSnapshot() {
        return { ...this.props };
    }
}
//# sourceMappingURL=tenant.entity.js.map